module.exports = __webpack_public_path__ + "img/tianan.fd761aff.png";